import { render, staticRenderFns } from "./Keyboard80.vue?vue&type=template&id=7ede431a&scoped=true&"
import script from "./Keyboard80.vue?vue&type=script&lang=js&"
export * from "./Keyboard80.vue?vue&type=script&lang=js&"
import style0 from "./Keyboard80.vue?vue&type=style&index=0&id=7ede431a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ede431a",
  null
  
)

export default component.exports